import { Grid, Typography, withStyles } from '@material-ui/core';
import React from 'react';

export const ScheduleDayListView = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
  },
}))(({ classes, date, hideDate }) => (
  <Grid className={classes.root} container>
    <Typography variant="h6">{hideDate ? date.format('ddd') : date.format('ddd D MMM')}</Typography>
  </Grid>
));
